import { registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { poolsDataProvider } from './dataProvider';

export function initSocialTradingPoolsDataProvider() {
  registerModuleDataProvider(Resources.socialTradingPools, poolsDataProvider);
}

initSocialTradingPoolsDataProvider();
